import React, {FC} from 'react';
import styled from 'styled-components';

import {
  ButtonVariantsEnum,
  findButtonColors,
} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {AccountModel} from '../../../models/api/accountModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {AccountAvatar} from '../avatars/accountAvatar';
import {ContactAvatar} from '../avatars/contactAvatar';
import {DropdownItemAvatar} from './dropdownItemAvatar';

/*
 * Constants.
 */

const avatarSizeWithAccount = 16;

/*
 * Props.
 */

export interface DropdownItemContactWithAccountAvatarProps {
  contact: VisualContactModel;
  account: AccountModel | undefined;
}

/*
 * Styles.
 */

const StyledSmallDropdownItemAvatar = styled(DropdownItemAvatar)`
  position: relative;
  width: 20px;
  height: 20px;
  z-index: 0;
`;

const StyledSmallContactAvatar = styled(ContactAvatar)`
  position: absolute;
  top: -2px;
  left: -2px;
  z-index: 2;
`;

const StyledSmallAccountAvatar = styled(AccountAvatar)`
  position: absolute;
  bottom: -2px;
  right: -2px;
  z-index: 1;
`;

/*
 * Component.
 */

export const DropdownItemContactWithAccountAvatar: FC<DropdownItemContactWithAccountAvatarProps> = ({
  account,
  contact,
}) => {
  const theme = useUserTheme();
  if (account) {
    const buttonColors = findButtonColors(theme);
    const borderColor = buttonColors[ButtonVariantsEnum.SECONDARY].background(PaletteColorsEnum.GREY);
    const borderHoverColor = buttonColors[ButtonVariantsEnum.SECONDARY].backgroundHover(
      PaletteColorsEnum.GREY,
    );
    return (
      <StyledSmallDropdownItemAvatar>
        <StyledSmallContactAvatar
          visualContact={contact}
          size={avatarSizeWithAccount}
          borderColor={borderColor}
          borderHoverColor={borderHoverColor}
        />
        <StyledSmallAccountAvatar account={account} size={avatarSizeWithAccount} avatarIconSize={8} />
      </StyledSmallDropdownItemAvatar>
    );
  }
  return (
    <DropdownItemAvatar>
      <ContactAvatar visualContact={contact} size={VisualSizesEnum.MEDIUM} />
    </DropdownItemAvatar>
  );
};
